var ASH_AGE, ASH_GENERAL_INFORMATION_FORM_ITEMS, ASH_RECOMMENDATION_FORM_ITEMS, CARE_PHASE, CLINICAL_DOMAIN, CLINICAL_SETTINGS, DISEASE_CONDITION, DISEASE_CONDITION_KEYS, DISEASE_TO_TOPIC_MAP, PATIENT_POPULATIONS, PlainLanguageLinksField, RECOMMENDATION_STATUS, TOPICS, VERSION_OPTIONS,
  __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

VERSION_OPTIONS = require('lib/extraction_form_helper').VERSION_OPTIONS;

PlainLanguageLinksField = require('components/covid_extraction_form/plain_language_links_field');

TOPICS = _.map(["acute_lymphoblastic_leukemia_in_adolescents_and_young_adults", "acute_myeloid_leukemia", "amyloidosis", "aplastic_anemia", "immune_thrombocytopenia", "iron_deficiency_anemia", "myelofibrosis", "sickle_cell_disease", "venous_thromboembolism", "von_willebrand_disease"], function(value) {
  return {
    value: value,
    text: $.t("es:recommendations.metadataExtractionForm.values.topics." + value)
  };
});

DISEASE_TO_TOPIC_MAP = {
  "acute_lymphoblastic_leukemia_in_adolescents_and_young_adults": ["newly_diagnosed_b_cell_all", "newly_diagnosed_t_cell_all", "philadelphia_chromosome_positive_all", "relapsed_refractory_all"],
  "acute_myeloid_leukemia": ["newly_diagnosed_aml", "aml_with_secondary_changes", "aml_unfit_for_intensive_chemotherapy"],
  "amyloidosis": ["suspected_al_amyloidosis", "confirmed_al_amyloidosis", "cardiac_al_amyloidosis", "renal_al_amyloidosis", "hepatic_or_gastrointestinal_al_amyloidosis", "peripheral_autonomic_neuropathy_due_to_al_amyloidosis", "attr"],
  "aplastic_anemia": ["aplastic_anemia_general", "severe_aplastic_anemia", "very_severe_aplastic_anemia"],
  "immune_thrombocytopenia": ["persistent_chronic_itp", "steroid_refractory_itp", "second_line_itp_eg_tpo_ra_rituximab_splenectomy_candidates"],
  "iron_deficiency_anemia": ["iron_deficiency_anemia_general", "iron_deficiency_anemia_in_pregnancy"],
  "myelofibrosis": ["primary_myelofibrosis", "post_pv_et_myelofibrosis", "symptomatic_myelofibrosis_eg_splenomegaly_constitutional_symptoms", "high_risk_myelofibrosis"],
  "sickle_cell_disease": ["scd_with_acute_pain", "scd_with_chronic_pain", "scd_with_cerebrovascular_disease", "scd_with_cardiopulmonary_disease", "scd_with_kidney_disease", "scd_undergoing_stem_cell_transplant", "sickle_cell_disease_general", "scd_requiring_transfusion_support"],
  "venous_thromboembolism": ["general_vte_unprovoked", "general_vte_provoked", "general_vte_no_special_condition", "cancer_associated_vte", "pregnancy_associated_vte", "catheter_related_vte", "hospital_acquired_vte_medical", "surgical_vte", "thrombophilia_inherited_acquired_thrombophilia", "deep_vein_thrombosis_dvt", "pulmonary_embolism_pe", "postpartum_associated_vte", "heparin_induced_thrombocytopenia_hit", "vte_and_covid_19_sars_cov_2_infection"],
  "von_willebrand_disease": ["type_1_vwd", "type_2_vwd", "type_3_vwd", "vwd_type_not_yet_specified", "suspected_undiagnosed_vwd_diagnostic_workup"]
};

DISEASE_CONDITION_KEYS = ["newly_diagnosed_b_cell_all", "newly_diagnosed_t_cell_all", "philadelphia_chromosome_positive_all", "relapsed_refractory_all", "newly_diagnosed_aml", "aml_with_secondary_changes", "aml_unfit_for_intensive_chemotherapy", "suspected_al_amyloidosis", "confirmed_al_amyloidosis", "cardiac_al_amyloidosis", "renal_al_amyloidosis", "hepatic_or_gastrointestinal_al_amyloidosis", "peripheral_autonomic_neuropathy_due_to_al_amyloidosis", "attr", "aplastic_anemia_general", "severe_aplastic_anemia", "very_severe_aplastic_anemia", "persistent_chronic_itp", "steroid_refractory_itp", "second_line_itp_eg_tpo_ra_rituximab_splenectomy_candidates", "iron_deficiency_anemia_general", "iron_deficiency_anemia_in_pregnancy", "primary_myelofibrosis", "post_pv_et_myelofibrosis", "symptomatic_myelofibrosis_eg_splenomegaly_constitutional_symptoms", "high_risk_myelofibrosis", "scd_with_acute_pain", "scd_with_chronic_pain", "scd_with_cerebrovascular_disease", "scd_with_cardiopulmonary_disease", "scd_with_kidney_disease", "scd_undergoing_stem_cell_transplant", "sickle_cell_disease_general", "scd_requiring_transfusion_support", "general_vte_unprovoked", "general_vte_provoked", "general_vte_no_special_condition", "cancer_associated_vte", "pregnancy_associated_vte", "catheter_related_vte", "hospital_acquired_vte_medical", "surgical_vte", "thrombophilia_inherited_acquired_thrombophilia", "deep_vein_thrombosis_dvt", "pulmonary_embolism_pe", "postpartum_associated_vte", "heparin_induced_thrombocytopenia_hit", "vte_and_covid_19_sars_cov_2_infection", "type_1_vwd", "type_2_vwd", "type_3_vwd", "vwd_type_not_yet_specified", "suspected_undiagnosed_vwd_diagnostic_workup"];

DISEASE_CONDITION = _.map(DISEASE_CONDITION_KEYS, function(value) {
  return {
    value: value,
    text: $.t("settings:general_information.values.recommendationModule." + value)
  };
});

ASH_AGE = _.map(["children", "adolescents_young_adults", "adults", "older_adults", "all_ages"], function(value) {
  return {
    value: value,
    text: $.t("settings:general_information.values.ash.age." + value)
  };
});

CLINICAL_SETTINGS = _.map(["inpatient_hospital", "outpatient", "emergency_acute_care", "procedural", "community_primary_care"], function(value) {
  return {
    value: value,
    text: $.t("settings:general_information.values.clinicalSettings." + value)
  };
});

PATIENT_POPULATIONS = _.map(["pregnant_or_postpartum_patients", "patients_with_cancer", "patients_with_prior_vte", "patients_with_central_venous_catheters", "hospitalized_medical_patients_at_risk_of_vte", "hospitalized_surgical_patients_at_risk_of_vte", "critically_ill_icu_patients", "patients_with_renal_impairment", "patients_with_liver_disease", "patients_with_obesity", "patients_with_thrombophilia"], function(value) {
  return {
    value: value,
    text: $.t("settings:general_information.values.patientPopulations." + value)
  };
});

CARE_PHASE = _.map(["diagnostic_phase", "active_treatment", "long_term_chronic_management", "post_treatment_surveillance_survivorship", "end_of_life_palliative"], function(value) {
  return {
    value: value,
    text: $.t("settings:general_information.values.carePhase." + value)
  };
});

CLINICAL_DOMAIN = _.map(["diagnosis_evaluation", "risk_assessment_screening", "treatment_management", "prevention_prophylaxis", "monitoring_follow_up", "supportive_care_symptom_management", "transfusion_blood_product_support", "procedures_interventions"], function(value) {
  return {
    value: value,
    text: $.t("settings:general_information.values.clinicalDomain." + value)
  };
});

RECOMMENDATION_STATUS = _.map(["current", "superseded_replaced", "in_development", "regional_adaptation", "living_guideline_update"], function(value) {
  return {
    value: value,
    text: $.t("settings:general_information.values.recommendationStatus." + value)
  };
});

ASH_GENERAL_INFORMATION_FORM_ITEMS = {
  main: [
    {
      fieldKey: 'guidelineNoId',
      type: 'text'
    }, {
      fieldKey: 'title',
      type: 'text'
    }, {
      fieldKey: 'slug',
      helperTextFromI18n: true,
      showClear: false,
      type: 'text'
    }, {
      fieldKey: 'generalDescription',
      showClear: false,
      type: 'editorText'
    }, {
      fieldKey: 'authors',
      type: 'text'
    }, {
      fieldKey: 'version',
      type: 'radioOptions',
      options: VERSION_OPTIONS,
      placeholderFromI18n: true
    }, {
      fieldKey: 'fullReference',
      type: 'text'
    }, {
      fieldKey: 'publicationDate',
      type: 'date'
    }, {
      fieldKey: 'source',
      type: 'text',
      placeholderFromI18n: true
    }, {
      fieldKey: 'sourceDocumentLink',
      type: 'text',
      placeholderFromI18n: true
    }, {
      fieldKey: 'whoIrisId',
      type: 'text'
    }, {
      fieldKey: 'isbn',
      type: 'text'
    }, {
      fieldKey: 'doi',
      type: 'text'
    }, {
      fieldKey: 'pmid',
      type: 'text'
    }, {
      fieldKey: 'latestLiteratureSearchDate',
      type: 'date'
    }, {
      fieldKey: 'topic',
      type: 'select',
      options: TOPICS
    }
  ]
};

ASH_RECOMMENDATION_FORM_ITEMS = {
  main: [
    {
      fieldKey: 'ageGroup',
      type: 'multiSelect',
      options: ASH_AGE
    }, {
      fieldKey: 'topic',
      type: 'select',
      options: TOPICS
    }, {
      fieldKey: 'diseaseCondition',
      type: 'multiSelect',
      filteredOptions: function(data) {
        return _.filter(DISEASE_CONDITION, function(condition) {
          var _ref;
          return _ref = condition.value, __indexOf.call(DISEASE_TO_TOPIC_MAP[data['topic']] || [], _ref) >= 0;
        });
      }
    }, {
      fieldKey: 'clinicalSettings',
      type: 'multiSelect',
      options: CLINICAL_SETTINGS
    }, {
      fieldKey: 'patientPopulations',
      type: 'multiSelect',
      options: PATIENT_POPULATIONS
    }, {
      fieldKey: 'carePhase',
      type: 'multiSelect',
      options: CARE_PHASE
    }, {
      fieldKey: 'clinicalDomain',
      type: 'multiSelect',
      options: CLINICAL_DOMAIN
    }, {
      fieldKey: 'recommendationStatus',
      type: 'multiSelect',
      options: RECOMMENDATION_STATUS
    }, {
      fieldKey: 'relatedRecommendationLinks',
      type: 'custom',
      customWithArray: true,
      component: PlainLanguageLinksField,
      showClear: false,
      additionalProps: {
        addBtnLabel: $.t('/actions.add_related_recommendation')
      }
    }
  ]
};

module.exports = {
  ASH_GENERAL_INFORMATION_FORM_ITEMS: ASH_GENERAL_INFORMATION_FORM_ITEMS,
  ASH_RECOMMENDATION_FORM_ITEMS: ASH_RECOMMENDATION_FORM_ITEMS
};
